import { render, staticRenderFns } from "./Obituario.vue?vue&type=template&id=b6aa9682"
import script from "./Obituario.vue?vue&type=script&lang=js"
export * from "./Obituario.vue?vue&type=script&lang=js"
import style0 from "./Obituario.vue?vue&type=style&index=0&id=b6aa9682&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports